module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pressTabList"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), (_vm.msgStatus == 21) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("暂缓登记")]) : _vm._e(), _vm._v(" "), (_vm.msgStatus == 3) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, _vm._l(((_vm.opMsg || '').split('；')), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(item ? item + (index == (_vm.opMsg || "").split("；").length - 1 ? "" : "；") : "") + "\n          ")])
  }))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabCage.tabDat1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "材料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成进度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.status, "pgress")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row, "time")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pubStatus == 1 || _vm.pubStatus == 0) ? _c('UpBtn', {
          attrs: {
            "fileID": _vm.zeroStoreage[scope.row.id] ? _vm.zeroStoreage[scope.row.id].fileId : '',
            "btnProps": scope.row,
            "pubStatus": (scope.row.materialTitle == '整改报告' && _vm.pubStatus == 0 && _vm.isModifyStage == '1') ||
              (scope.row.materialTitle != '整改报告' && _vm.pubStatus == 0) ?
              0 :
              1
          },
          on: {
            "zeroTabStore": _vm.zeroStoreCtrls
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tabTips"
  }, [_vm._v("注：上传文件格式为WORD，文件大小不超过100M")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("材料2：音像制品出版单位年度核验表、音像制品出版情况表（"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果已经填写了电子数据，部分表格可以通过数据拷贝的方式获取")]), _vm._v("）")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("材料2：电子出版物出版单位年度核验表、电子出版物出版情况表（"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果已经填写了音像数据，部分表格可以通过数据拷贝的方式获取")]), _vm._v("）")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "copyBtn",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('show')
      }
    }
  }, [_vm._v("数据拷贝")]), _vm._v(" "), (_vm.pressType == 1) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl2,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表1：音像制品出版单位年度核验表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表1：电子出版物出版单位年度核验表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabCage.tabDat2), function(item, inx) {
    return _c('tr', {
      key: "inx"
    }, [_c('td', [_vm._v("1-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(_vm.pubStatus == 0 && item.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 0 && item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 3)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "7"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 7) ? _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 8) ? _c('td') : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表2：音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表2：电子出版物出版情况表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.tabCage.tabDat3), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("2-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(_vm.pubStatus == 0 && item.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 0 && item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 3)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(3)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)])])
  })], 2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(4), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [(_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.upToPvc
    }
  }, [_vm._v("提交")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressDiag",
    attrs: {
      "title": "选择需要拷贝的表",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.checkList && _vm.checkList.length > 0) ? _c('div', [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n          数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。\n        ")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.codeArr),
      callback: function($$v) {
        _vm.codeArr = $$v
      },
      expression: "codeArr"
    }
  }, _vm._l((_vm.checkList), function(tab, index) {
    return _c('div', {
      staticClass: "selectItem"
    }, [_c('el-checkbox', {
      key: tab.id,
      attrs: {
        "label": tab.materialCode
      }
    }, [_vm._v(_vm._s("1-" + tab.materialCode.substr(2, 3)) + " " + _vm._s(tab.materialTitle))])], 1)
  }))], 1) : _c('div', {
    staticClass: "errors"
  }, [_vm._v("目前尚未生成可拷贝的表")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.checkList && _vm.checkList.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('act')
      }
    }
  }, [_vm._v("拷 贝")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料1：工作总结    ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right"
    }
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTips"
  }, [_c('div', {
    staticClass: "tipBold"
  }, [_vm._v("注：")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("1、")]), _vm._v("\n            所有表格填写项目，若本单位无此项内容，文字项请填写“无”，数字项请填写“0”。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("2、")]), _vm._v("\n            核验年度如果没有发生表1-5、1-6、1-7、2-1的事项，则可以不用填写。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("3、")]), _vm._v("\n            表1-8可使用Excel进行批量导入。导入前需要先下载“导入模板”，并在“导入模板”文件中按其规定格式填写后才能批量导入。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("4、")]), _vm._v("\n            数据拷贝是指同时具有音像、电子业务的单位，在填写好音像材料后，两处材料一样的表格内容可以通过“数据拷贝”复制到电子出版物这边。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("5、")]), _vm._v("\n            导出打印表可以将标准格式Excel文件下载到本地电脑，下载的文件可以微调格式适应换行、换页后再打印，但不能修改内容。提交之后可从“核验进度”\n            菜单导出打印表。\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb271c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/pressComps/CommonTab.vue
// module id = 1680
// module chunks = 1